export default __webpack_public_path__ + "media/fonts/FiraMono/FiraMono-Bold-046e59758d24f5d342c4955e094416c1.otf";